<template>
  <component v-bind:is="current"></component>
</template>

<script>
import Byz from "./BYZ/CardOfBYZ";
import Comp from "./Predp/CardOfPred";
import Stud from "./Student/CardOfStudent";
export default {
  components: {
    Byz,
    Comp,
    Stud,
  },
  data: () => ({
    current: "Byz",
  }),
  created() {
    if (this.$ls.get("inAk") == undefined) {
      this.$router.replace("/");
    }
    var a = this.$route.params.idName;
    if (a == "Dan") {
      this.current = "Comp";
    } else if (a == "Ain") {
      this.current = "Stud";
    } else if (a == "Fil") {
      this.current = "Byz";
    }
  },
};
</script>